import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [tblusers, setTblusers] = useState([]);
const [arrtbls, setArrtbls] = useState([]);
const [tblindex, setTblindex]=useState({i:null});

const [wptusername, setWptusername] = useState({});
const [dowait, setDowait] = useState({on:false});

const [custype, setCustype] = useState([
<option value='' ></option>
,<option value='Corporate' >Corporate Customers</option>
,<option value='General' >Non-Corporate Customers</option>
]);



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

if (tblusers.length<1){
	wptappstoemail('', '');
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	//document.getElementsByName('searchcrit')[0].focus();
	
 },[JSON.stringify(tblusers)]);

useEffect(() => {

	console.log('wptusername.EMAIL: '+wptusername.EMAIL);//JSON.stringify(webuser)
	if (wptusername.EMAIL!=undefined){
		if (modal.open==false)
			toggleModalsm();
			
		}//end if
	
 },[wptusername]);


useEffect(() => {

if (tblindex.i!=null)
wptappstoemail(
	arrtbls[tblindex.i].TC_ISLAND
	,arrtbls[tblindex.i].PROCESS_AREA
	);
	
 },[tblindex.i]);


		


function searchcritChange(e){
//	setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if

function wptappstoemail(TC_ISLAND, PROCESS_AREA){

//const custype=searchcrit.name=='custype'?searchcrit.txt.trim():'';

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {TC_ISLAND:TC_ISLAND, PROCESS_AREA, PROCESS_AREA} )
  };		
  //if (TC_ISLAND=='' || PROCESS_AREA=='')
	setTblusers([]);
//
  fetch(resturl+'rarwpform/wptappstoemail',requestOptions)
      .then(res => res.json())
      .then(res => 	afterwptappstoemail(res, TC_ISLAND, PROCESS_AREA) )
      .catch(err => console.log(err));

}//end func

function getwptuser(e, USERNAME){

e.preventDefault();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:USERNAME} )
  };		

  fetch(resturl+'rarwpform/getwptuser',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptuser(res) )
      .catch(err => console.log(err));

}//end func


function updatewptusername(){

const params={
USERNAME : sessionStorage.getItem("USERNAME")
, wptuser : wptusername
	
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  fetch(resturl+'rarwpform/updatewptusername',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewptusername(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatewptusername(res){
	if (res.length==undefined)
		showsnackbar('something went wrong, please try again');
	else
		showsnackbar('changes were saved successfully');
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function aftergetwptuser(res){
if (res.length==undefined)
	return;

let datas={};

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
setWptusername(datas);

}//end func

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func

function handleWpappChange(e, WPT_APP_ID, submitted){
	e.preventDefault();
	
	navigate("/wptform",{state:{WPT_APP_ID:WPT_APP_ID, SUBMITTED_TO_CSC:submitted}});
}//end func

function afterwptappstoemail(res, TC_ISLAND, PROCESS_AREA){
if (res.length==undefined)
	return;
	
console.log('afterwptappstoemail, res.length: '+res.length);
if (TC_ISLAND=='' || PROCESS_AREA==''){
	setArrtbls(res);
	setTblindex({i:0});
	return;
	}//end if

let htmrows=[];
let key="";
res.map((col, index) => {
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	const appid=col['WPT_APP_ID'];
	const submitted=col['SUBMITTED_TO_CSC'];
	const MPE_NAME=col['MPE_NAME'];

	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='center' >{col['SUBMITTED_TO_CSC']}</td>
	<td align='center' >{col['STATUS']}</td>
	<td align='center'  >
		<a href="#" title={MPE_NAME} className="nodecor" onClick={(e)=>{handleWpappChange(e, appid, submitted);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{col['IMG_REF']}</a>
	</td>
	<td align='center' >{col['EMPL_ID']}</td>
	<td align='center' >{col['MPR_NAME']}</td>
	<td align='center' >{col['APP_TYPE']}</td>
	<td align='center' >{col['MPE_OCCUPATION']}</td>
	<td align='center' >{col['NATIONALITY']}</td>

		{/*
			<td align='center' >{col['CREATE_USER']}</td>
	<td align='center' >{col['PROCESS_AREA']}</td>
	<td align='center' >{col['TC_ISLAND']}</td>
	<td align='center' >{col['AP_LEVEL']}</td>	
	<td align='center' >{col['EMPL_ID']}</td>
		*/}

	</tr>;
	htmrows.push(htmrow);
	



});

console.log('htmrows.len: '+htmrows.length);
let temp=tblusers;
temp.push(
<>
<div align='center'>Location and Processing Area: {TC_ISLAND+" "+PROCESS_AREA}</div>
			<table align='center' className='customers' style={{width:"85%",marginBottom:"18px"}} >
			<thead>
			<tr>
				<th>#</th>
				<th>Date</th>
				<th>Status</th>
				<th>Applicant<br/>Immig. Ref #</th>
				<th>Employer<br/>Id</th>
				<th>Employer<br/>Name</th>
				<th>Applicant<br/>Type</th>
				<th>Occupoation</th>
				<th>Nationality</th>
			</tr>
			</thead>
			<tbody>
			{htmrows}
			</tbody>
			</table>
			</>
);
//tblusersIndex++;
setTblusers(temp);
const newi=tblindex.i+1;
if (newi<arrtbls.length)
	setTblindex({i:newi});
}//end func




function wptusernameChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setWptusername((prev) => {
return {...prev, [name]:value}
});	
}//end func



const yesnooptions = <>
		<option value="0" >No</option>
		<option value="1" >Yes</option>
		</>;
	
  return (
    <>
	
<div align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
	{/*customer type filter: <select name='custype' onChange={(e)=>{searchcritChange(e);}} >{custype}</select>*/}
	Queue of applications to be emailed to Corporate or General officers per Island
</div>
	{tblusers}


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >Email: </td>
			<td align='left' ><input name='EMAIL' defaultValue={wptusername.EMAIL} onChange={(e)=>{wptusernameChange(e);}}  /></td>
			</tr>
			<tr>
			<td align='right' >Full Name: </td>
			<td align='left' ><input name='FULLNAME' defaultValue={wptusername.FULLNAME}  onChange={(e)=>{wptusernameChange(e);}} autoComplete='off' placeholder='full name' /></td>
			</tr>
			<tr>
			<td align='right' >Voucher User: </td>
			<td align='left' ><input name='IRD_LOGIN_ID' defaultValue={wptusername.IRD_LOGIN_ID}  onChange={(e)=>{wptusernameChange(e);}} autoComplete='off' placeholder='Voucher User' /></td>
			</tr>
			<tr>
			<td align='right' >Corporate Customers: </td>
			<td align='left' >
			{/*<input name='CORP_CUSTOMERS' defaultValue={wptusername.CORP_CUSTOMERS}  onChange={(e)=>{wptusernameChange(e);}} autoComplete='off'  />*/}
			<select name='CORP_CUSTOMERS' value={wptusername.CORP_CUSTOMERS} onChange={(e)=>{wptusernameChange(e);}} >
			{yesnooptions}
			</select>
			</td>
			</tr>
			<tr>
			<td align='right' >General Customers: </td>
			<td align='left' >
			{/*<input name='GNRL_CUSTOMERS' defaultValue={wptusername.GNRL_CUSTOMERS}  onChange={(e)=>{wptusernameChange(e);}} autoComplete='off' />*/}
			<select name='GNRL_CUSTOMERS' value={wptusername.GNRL_CUSTOMERS} onChange={(e)=>{wptusernameChange(e);}} >
			{yesnooptions}
			</select>
			</td>
			</tr>


			<tr>
			<td align='right' >Primary App Processing: </td>
			<td align='left' >
			<select name='PRIMARY_AP' value={wptusername.PRIMARY_AP} onChange={(e)=>{wptusernameChange(e);}} >
			{yesnooptions}
			</select>
			</td>
			</tr>
			
			<tr>
			<td align='right' >Secondary App Processing: </td>
			<td align='left' >
			<select name='SECONDARY_AP' value={wptusername.SECONDARY_AP} onChange={(e)=>{wptusernameChange(e);}} >
			{yesnooptions}
			</select>
			</td>
			</tr>

			{/*
						<tr>
			<td align='right' >&nbsp;</td>
			</tr>
			*/}
			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.on && <button className="button" id='btnupdate' onClick={(e)=>{updatewptusername(e);}} >update this user</button>}
			</td>
			</tr>

	
			<tr>
			<td align='right' >last modified:</td>
			<td align='left' >
			 {wptusername.MODIFY_USER+" "+wptusername.MODIFY_DATE1}
			</td>
			</tr>	
			
			
			</tbody>
			</table>
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;